import { useEffect, useRef, useState } from "react";

const DEFAULT_MIN_MS = 600;

const useHeldLoading = (loading, minMs = DEFAULT_MIN_MS) => {
  const startedAt = useRef(Date.now());
  const [held, setHeld] = useState(true);

  useEffect(() => {
    if (loading) {
      setHeld(true);
      return undefined;
    }

    const elapsed = Date.now() - startedAt.current;
    if (elapsed >= minMs) {
      setHeld(false);
      return undefined;
    }

    const timer = setTimeout(() => setHeld(false), minMs - elapsed);
    return () => clearTimeout(timer);
  }, [loading, minMs]);

  return held;
};

export default useHeldLoading;
